import { useCallback, useMemo } from 'react';
import { useAssistantState } from '@assistant-ui/react';

import { Icon, Snackbar } from '@atom/mui';
import colors from '@atom/styles/colors';

import { useTextFromMessage } from '../../hooks/useTextFromMessage';
import { ChatAssistantMessageHookResponse } from '../types';

const styles = {
  icon: {
    fontSize: '1rem',
    width: '1rem',
    height: '1rem',
  },
};

export const useCopyAction = (): ChatAssistantMessageHookResponse => {
  const message = useAssistantState(state => state.message);
  const text = useTextFromMessage(message);

  const handleCopy = useCallback(() => {
    // NOTE this does not work in development since clipboard is only available over https connections
    navigator?.clipboard?.writeText(text);

    Snackbar.info({
      message: 'Copied.',
    });
  }, [text]);

  return useMemo<ChatAssistantMessageHookResponse>(
    () => ({
      available: true,
      type: 'standalone',
      ui: [
        {
          icon: (
            <Icon color={colors.neutral.gray} style={styles.icon}>
              content_copy
            </Icon>
          ),
          copy: 'Copy',
          onClick: handleCopy,
        },
      ],
    }),
    [handleCopy],
  );
};
